import React, { forwardRef } from 'react';
import { IconButton, IconButtonProps } from '@mui/material';
import { DashboardService } from '../shared/api/services/dashboardService';
import { ActionType } from '../shared/api/types';

interface UIIconButtonProps extends IconButtonProps {
  /** Optional logging context for UI event analytics */
  logAction?: {
    actionName?: string;
    pageName?: string;
    subSection?: string;
  };
}

const UIIconButton = forwardRef<HTMLButtonElement, UIIconButtonProps>(({ 
  onClick,
  logAction,
  children,
  ...props
}, ref) => {
  
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    // Fire-and-forget logging
    const actionName = logAction?.actionName || props['aria-label'] || 'Icon Button Click';
    DashboardService.logButtonAction({
      actionType: ActionType.BUTTON_CLICK,
      actionName,
      pageName: logAction?.pageName || "Generic",
      subSection: logAction?.subSection || "Action",
    }).catch(() => {});

    if (onClick) {
      onClick(event);
    }
  };

  return (
    <IconButton
      ref={ref}
      onClick={handleClick}
      {...props}
    >
      {children}
    </IconButton>
  );
});

UIIconButton.displayName = 'UIIconButton';

export default UIIconButton;
